import { LayoutScaleType } from '@base/model';

export const LayoutScale: LayoutScaleType = 13;
